import { UA, WebSocketInterface } from 'jssip';
import type { UAFactory, UALike } from './types';

export const createJsSipUA: UAFactory = (p) => {
  const ua = new UA({
    sockets: [new WebSocketInterface(p.wssUrl)],
    uri: p.uri,
    authorization_user: p.authorizationUser,
    password: p.password,
    register: true,
    register_expires: 300,
    session_timers: false,
    connection_recovery_min_interval: 2,
    connection_recovery_max_interval: 60,
    user_agent: 'DLRG-Web-Telefon',
  });
  return ua as unknown as UALike;
};
